import AOS from "aos";

Math.between = function(min, number, max) {
    if (isNaN(number)) number = min;
    return Math.min(Math.max(parseInt(number), min), max);
}

var urlparams = {};
var x = document.location.search.substring(1).split("&");
for (var i in x) {
    var z = x[i].split("=", 2);
    urlparams[z[0]] = unescape(z[1]);
}
window.urlparams = urlparams;

function setViewportHeight() {
    document.body.style.setProperty('--viewport-height', window.innerHeight + 'px');
}

document.addEventListener('cookiebundle-on-accept-or-change', function (event) {
    if (window.gtag && event.detail?.categories?.includes('analytics')) {
        window.gtag('consent', 'update', {
            'ad_user_data': 'granted',
            'ad_personalization': 'granted',
            'ad_storage': 'granted',
            'analytics_storage': 'granted'
        });
    }
});

$(document).ready(function() {
    console.log('document.ready');
    var scrollWidth = window.innerWidth - document.body.clientWidth;
    document.body.style.setProperty('--scrollbar-width', scrollWidth + 'px');
    $('.back-button').click(function(ev) {
        history.back();
        return false;
    });
    setViewportHeight()
    window.addEventListener("resize", setViewportHeight);
    window.addEventListener("DOMContentLoaded", setViewportHeight);

    if (window.AOS) {
        AOS.init();
    }

    // prevent browser from opening files
    $(document).on('dragover drop', function (e) {
        e.preventDefault();
    });

    var touchDevice = ('ontouchstart' in document.documentElement);
    if (touchDevice) {
        document.body.classList.add('is-touch');
    }

    if (window.mCustomScrollbar) {
        // $('.main-title nav, .custom-scroll').mCustomScrollbar({
        //     axis: 'x',
        //     theme:"dark-thin",
        //     autoHideScrollbar: true,
        //     autoExpandScrollbar: true,
        //     advanced: {autoExpandHorizontalScroll:2},
        //
        //     // autoExpandScrollbar:true,
        //     //advanced:{autoExpandHorizontalScroll:true},
        //     // scrollbarPosition: 'outside',
        //
        //     // theme: 'minimal-dark',
        //     // alwaysShowScrollbar: 0,
        //     // advanced:{ autoUpdateTimeout: 200 },
        //     // scrollbarPosition: 'outside',
        //     // callbacks:{
        //     //     onUpdate: function() {
        //     //         $(this).find('.mCSB_container').width(Math.floor($(this).width()) - 2);
        //     //     }
        //     // },
        // });
    }

    $('#main-nav, #slidenav [data-open]').click(function() {
        document.body.classList.add('nav-open');
        useroptions.addUserOption('asside-nav', 'open');
    });
    $('#slidenav [data-close]').click(function() {
        document.body.classList.remove('nav-open');
        useroptions.addUserOption('asside-nav', 'closed');
    });

    $('#slidenav .nav-search .ctl-autocompleter').on('changed', function(ev, data) {
        location.href = '/Planner/Planner/ProjectPlan/'+data.value+'#nav-plan';
    });

    if ($('.page-dashboard').length === 1 && document.body.clientWidth > 992) {
        if (useroptions.getUserOption('asside-nav', 'open') === 'open') {
            document.body.classList.add('nav-open');
        }
    }

    setInterval(function() {
        connection.getJson('/Auth/Ping', {
            onError: function() {},
        });
    }, 60000);

    $('.send-error').on('click', function() {
        var popup = notification.notifyPopup("Idee / Feedback / Support", "", {
            spinner: true,
            width: '600px'
        });
        connection.getHtmlPart("/Help/ErrorMailForm", {
            onSuccess: function(data) {
                notification.insertContent(popup, data);
                popup.find('.modal-body').endProcess();

                popup.find('form').submit(function(ev) {
                    ev.preventDefault();
                    var btn = popup.find('[type="submit"]');
                    btn.attr("disabled", "disabled");
                    var field = popup.find('#message');
                    popup.find('.is-invalid').removeClass('is-invalid');
                    popup.find('.invalid-feedback').remove();
                    var message = field.val();
                    if (message.trim() !== "") {
                        console.log('senden');
                        connection.getJson("/Help/ErrorMailForm", {
                            type: 'post',
                            timeout: 20000,
                            data: {
                                message: message,
                                file: popup.find('[name="attachment"]').val(),
                                type: popup.find('[name="type"]').val(),
                                debugInfos: {
                                    URL: window.location.href,
                                    UserAgent: window.navigator.userAgent,
                                    ScreenSize: window.screen.width + " / " + window.screen.height,
                                    BrowserSize: window.innerWidth + " / " + window.innerHeight,
                                },
                            },
                            onSuccess: function () {
                                messaging.showGlobalMessage('success', null, 'Deine Nachricht wurde übermittelt.');
                                notification.close(popup);
                            }
                        });
                    } else {
                        var container = field.parent();
                        container.addClass('is-invalid');
                        container.append($('<div class="invalid-feedback">Erfasse eine Nachricht.</div>'));
                        btn.attr("disabled", null);
                    }
                    return false;
                });
                var dzEl = popup.find('[data-upload-container]');
                dzEl.on('file-added', function(e, data) {
                    var value = popup.find('[name="attachment"]').val();
                    dzEl.find('.dz-clickable span').remove();
                    dzEl.find('.dz-clickable').append($(`<div>${data.file.name}</div>`));
                    popup.find('[name="attachment"]').val(value + "," + data.response.filename);
                });
                onContentReady(popup);
            }
        });
        return false;
    });
    onContentReady($('body'));
});

function onContentReady(container) {
    console.log('onContentReady', container);
    // magnific popup
    $(document).trigger('content-ready', [container]);
    if ($.fn.magnificPopup) {
        container.find('.magnific-image').magnificPopup({type: 'image'});
        container.find('.magnific-video').magnificPopup({type: 'iframe'});
        container.find('.magnific-gallery').each(function () {
            var items = [];
            $.each($(this).find('a'), function() {
                var src = $(this).attr('href');
                if (src.indexOf('.webm') >= 0) {
                    items.push({
                        src: '<div class="mfp-figure"><button title="Close (Esc)" type="button" class="mfp-close">×</button><video controls autoplay muted><source type="video/webm" src="' + src + '" /></video></div>',
                        type: 'inline'
                    });
                } else {
                    items.push({
                        src: src,
                        type: 'image'
                    });
                }
            });
            $(this).magnificPopup({
                // type: 'inline',
                // delegate: 'a',
                gallery: {
                    enabled: true,
                    navigateByImgClick: true,
                    preload: [0, 1],
                    tPrev: 'Zurück',
                    tNext: 'Vorwärts',
                    tCounter: '%curr% von %total%'
                },
                items: items,
            });
        });
    }

    container.find('[data-toggle="tooltip"]').tooltip();

    container.find('a[data-mime*="image/"]').magnificPopup({type: 'image'});
    container.find('a[data-mime="application/pdf"]').magnificPopup({
        type: 'iframe',
        mainClass: 'flip-book-content',
        iframe: {
            patterns: {
                pdf_viewer: {
                    index: '/Document/Download',
                    id: function (url) {
                        var params = url.split("/");
                        var id = params[params.length - 1];
                        console.log('pdf viewer', url, id);
                        return id;
                    },
                    src: '/Document/PdfViewer/%id%'
                },
            }
        }
    });

    $('[data-href]').click(function(ev) {
        if (ev.target && $(ev.target).is('a')) {
            // handle links inside as normal links
            return true;
        }
        if (ev.target && ($(ev.target).is('.disable-href') || $(ev.target).closest('.disable-href').length >= 1)) {
            // handle links inside as normal links
            return true;
        }
        location.href = $(this).attr('data-href');
        return false;
    });

    container.find('[data-copy]').click(function() {
        var me = $(this);
        copyTextToClipboard(me.attr('data-copy'));
        toastr.info(me.attr('data-copy-info') ?? "Der Link wurde in die Zwischenablage kopiert.", "Ok", {});
    });

    container.find('.dropdown-submenu a').on("click", function(e){
        $(this).next('ul').toggle();
        e.stopPropagation();
        e.preventDefault();
    });

    container.find('.view-password').each(function() {
        var me = $(this);
        var input = me.find('input');
        me.find('.btn').click(function() {
            debugger;
            if (input.attr("type") === "password") {
                input.attr("type", "text");
                me.find('i').removeClass('fa-eye').addClass('fa-eye-slash');
            } else {
                input.attr("type", "password");
                me.find('i').addClass('fa-eye').removeClass('fa-eye-slash');
            }
            return false;
        });
    });
}
window.onContentReady = onContentReady;

$(document).on('content-ready', function (ev, container) {
    container.find('.dropdown').on('hide.bs.dropdown', function (e) {
        if (e.clickEvent) {
            var clickTarget = $(e.clickEvent.target);
            if (clickTarget.is('.prevent-close') || clickTarget.closest('.prevent-close').length >= 1) {
                e.preventDefault();
            }
        }
    });
});

function fallbackCopyTextToClipboard(text) {
    var textArea = document.createElement("textarea");
    textArea.value = text;

    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'successful' : 'unsuccessful';
        console.log('Fallback: Copying text command was ' + msg);
    } catch (err) {
        console.error('Fallback: Oops, unable to copy', err);
    }

    document.body.removeChild(textArea);
}

function copyTextToClipboard(text) {
    if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(text);
        return;
    }
    navigator.clipboard.writeText(text).then(function() {
        console.log('Async: Copying to clipboard was successful!');
    }, function(err) {
        console.error('Async: Could not copy text: ', err);
    });
}
window.copyTextToClipboard = copyTextToClipboard;
